
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/christmas",
      function () {
        return require("private-next-pages/christmas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/christmas"])
      });
    }
  